import { useState, useEffect } from "react";
import { useCart } from "../../../hooks/query";

export function useSupplierCompareUpdate(
    itemSupplierSelections: Record<string, string>,
    openModal: boolean,
    selectedValues: Record<string, any>,
    suppliers: any[],
    comparisonResults: any[],
    setOpenModal: (open: boolean) => void
) {
    const { useUpdate } = useCart();
    const updateCartSvc = useUpdate();

    const [localSelections, setLocalSelections] = useState<Record<string, string>>({});

    useEffect(() => {
        if (openModal) {
            setLocalSelections(itemSupplierSelections);
        }
    }, [openModal, itemSupplierSelections]);

    const onItemSupplierSelect = (productName: string, supplierName: string) => {
        setLocalSelections((prev) => ({ ...prev, [productName]: supplierName }));
    };

    const handleConfirm = async () => {
        try {
            const promises = Object.values(selectedValues).map(async (item: any) => {
                if (!item || !item.id || !item.value) return;

                const chosenSupplierName = localSelections[item.value];
                if (!chosenSupplierName) return;

                const supplierObj = suppliers.find((s: any) => s.Name === chosenSupplierName);
                if (!supplierObj) return;

                const comparisonSupplierData = comparisonResults.find((s: any) => s.SupplierName === chosenSupplierName);
                let unitPrice = null;
                if (comparisonSupplierData && comparisonSupplierData.SupplierInventory) {
                    const itemData = comparisonSupplierData.SupplierInventory.find((inv: any) => inv.ProductName === item.value);
                    if (itemData && itemData.UnitPrice !== undefined) {
                        unitPrice = itemData.UnitPrice;
                    }
                }

                return updateCartSvc.mutateAsync({
                    Id: item.id,
                    SupplierId: supplierObj.Id,
                    UnitPrice: unitPrice,
                });
            });

            await Promise.all(promises);
            setOpenModal(false);
        } catch (err) {
            console.error("Failed to update cart selections: ", err);
        }
    };

    return {
        localSelections,
        onItemSupplierSelect,
        handleConfirm,
    };
}
